export default function useCopy() {
	const copyText = async (text: string) => {
		if (import.meta.client) {
			const clipBoard = navigator.clipboard

			if (text && 'clipboard' in navigator) {
				try {
					await clipBoard.writeText(text)
					useNotification().alert({ status: 200, message: 'Copied to clipboard.' })
				} catch (error) {
					console.error(error)
					useNotification().alert({ status: 500, message: 'Something went wrong with copying to clipboard.' })
				}
			} else {
				useNotification().alert({ status: 500, message: 'Clipboard not supported or unavailable' })
			}
		}
	}

	return { copyText }
}
